import Axios from 'axios';

export type SyncItemErrorKind = 'network' | 'client' | 'server';

type ErrorLike = {
  response?: { status?: number };
  message?: string;
  code?: string;
  name?: string;
};

/**
 * Network/timeout stops the run. 4xx (and API validation strings) fail one item.
 * 5xx is retried by SyncManager.
 */
export function classifySyncItemError(error: unknown): SyncItemErrorKind {
  if (typeof error === 'string') {
    return 'client';
  }

  const err = error as ErrorLike;
  const status = err?.response?.status;
  if (typeof status === 'number' && status >= 500) {
    return 'server';
  }
  if (typeof status === 'number' && status >= 400 && status < 500) {
    return 'client';
  }

  const canceled =
    Axios.isCancel(error) ||
    err?.code === 'ERR_CANCELED' ||
    err?.code === 'ECONNABORTED' ||
    err?.name === 'AbortError' ||
    err?.name === 'CanceledError';

  if (canceled || err?.message === 'Network Error' || !err?.response) {
    return 'network';
  }

  return 'client';
}
